window.addEventListener('load', () => {
    const bookingButtons = document.querySelectorAll('button[data-set-active-booking]');
    const accountButtons = document.querySelectorAll('[data-location-mind-body-id]')

    for ( let bookingButton of bookingButtons ) {
        const parentPanel = bookingButton.closest('.booking-panel');
        const toggleSections = parentPanel.querySelectorAll('[data-open]');

        for (let toggleSection of toggleSections) {
            if (toggleSection.dataset.setActiveBooking === (Cookies.get('lastBookingPreference'))) {
                toggleSection.dataset.open = 'true';
            }
        }

        for (let accountButton of accountButtons) {
            if (accountButton.dataset.locationMindBodyId === (Cookies.get('lastBookingPreference'))) {
                accountButton.closest('.account-button-container').classList.remove('hidden');
            } else if (!Cookies.get('lastBookingPreference') && (accountButton.dataset.locationMindBodyId === '0')) {
                accountButton.closest('.account-button-container').classList.remove('hidden');
            } else {
                accountButton.closest('.account-button-container').classList.add('hidden');
            }
        }

        bookingButton.addEventListener('click', () => {
            const activeMindBodySiteId = bookingButton.dataset.setActiveBooking;
            Cookies.set('lastBookingPreference', activeMindBodySiteId, { expires: 31 });

            for (let toggleSection of toggleSections) {
                toggleSection.dataset.open = 'false';
            }

            for (let toggleSection of toggleSections) {
                if (toggleSection.dataset.setActiveBooking === activeMindBodySiteId) {
                    toggleSection.dataset.open = 'true';
                }
            }

            for (let accountButton of accountButtons) {
                if (accountButton.dataset.locationMindBodyId === activeMindBodySiteId) {
                    accountButton.closest('.account-button-container').classList.remove('hidden');
                } else if (!Cookies.get('lastBookingPreference') && (accountButton.dataset.setActiveBooking === '0')) {
                    accountButton.closest('.account-button-container').classList.remove('hidden');
                } else {
                    accountButton.closest('.account-button-container').classList.add('hidden');
                }
            }
        });
    }
});